import React from 'react';
import { FaCloud, FaCode, FaCogs, FaDatabase, FaGlobe, FaMobileAlt, FaPlug } from 'react-icons/fa';
import { SiAndroidstudio, SiDart, SiFirebase, SiFlutter, SiGithub, SiJavascript, SiMongodb, SiNodedotjs, SiPostman } from 'react-icons/si';

const skillGroups = [
  { title: 'Mobile development', icon: FaMobileAlt, skills: [{ name: 'Flutter', icon: SiFlutter }, { name: 'Dart', icon: SiDart }, { name: 'State Management', icon: FaCogs }, { name: 'Shared Preferences', icon: FaCode }] },
  { title: 'Backend & cloud', icon: FaDatabase, skills: [{ name: 'Firebase', icon: SiFirebase }, { name: 'Firebase Functions', icon: FaCloud }, { name: 'Node.js', icon: SiNodedotjs }, { name: 'MongoDB', icon: SiMongodb }] },
  { title: 'APIs & architecture', icon: FaPlug, skills: [{ name: 'REST APIs', icon: FaCode }, { name: 'Agora', icon: FaPlug }, { name: 'MVC / MVVM', icon: FaCogs }, { name: 'CRUD Operations', icon: FaCode }] },
  { title: 'Web', icon: FaGlobe, skills: [{ name: 'HTML', icon: FaCode }, { name: 'CSS', icon: FaCode }, { name: 'JavaScript', icon: SiJavascript }] },
  { title: 'Tools & development', icon: FaCogs, skills: [{ name: 'Git', icon: FaCode }, { name: 'GitHub', icon: SiGithub }, { name: 'VS Code', icon: FaCode }, { name: 'Android Studio', icon: SiAndroidstudio }, { name: 'Postman', icon: SiPostman }] },
];

export default function Skills() {
  return (
    <section className="border-y border-slate-800/70 px-4 py-16 sm:px-6 sm:py-24 lg:px-8" id="skills">
      <div className="site-container">
        <div className="mb-8 max-w-2xl sm:mb-12">
          <p className="section-eyebrow">Tech stack</p>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-5xl">Technologies I work with.</h2>
          <p className="mt-5 text-base leading-7 text-slate-400">A practical toolkit shaped by the applications and integrations in my portfolio.</p>
        </div>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {skillGroups.map(({ title, icon: GroupIcon, skills }) => (
            <article key={title} className="surface-card p-6 transition hover:border-slate-500">
              <div className="flex items-center gap-3">
                <GroupIcon className="text-cyan-300" aria-hidden="true" />
                <h3 className="text-sm font-bold text-white">{title}</h3>
              </div>
              <div className="mt-6 flex flex-wrap gap-2">
                {skills.map(({ name, icon: Icon }) => (
                  <span key={name} className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-900/70 px-3 py-2 text-xs font-semibold text-slate-300">
                    <Icon aria-hidden="true" />
                    {name}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
